import { ScreenOrientation } from '@ionic-native/screen-orientation';
import firebase from "@/utils/Firebase";
import { FCM } from '@capacitor-community/fcm';

import { PushNotifications } from '@capacitor/push-notifications';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Device as CapacitorDevice } from '@capacitor/device';
import { StatusBar as CapacitorStatusBar } from '@capacitor/status-bar';
import { Keyboard as CapacitorKeyboard} from '@capacitor/keyboard';


let registrationListener = null
let notificationsListener = null
let notificationReceivedListener = null
let registrationErrorListener = null

export const Keyboard = {
    async setResizeMode(mode = 'native') {
        if (await Device.isIOS()) {
            await CapacitorKeyboard.setResizeMode({ mode })
        }
    },
    onKeyboardHide: (callback = () => { }) => {
        CapacitorKeyboard.addListener('keyboardDidHide', callback)
    },
    initAvoid: () => {
        CapacitorKeyboard.addListener('keyboardWillShow', async () => {
            if (await Device.isIOS()) await CapacitorKeyboard.setResizeMode({ mode: 'native' })
        })
        CapacitorKeyboard.addListener('keyboardDidHide', async () => {
            if (await Device.isIOS()) await CapacitorKeyboard.setResizeMode({ mode: 'none' })
        })
    },
    clearListeners: () => {
        CapacitorKeyboard.removeAllListeners()
    }
}

export const Notifications = {

    pushRequestPermission: async () => {
        return await PushNotifications.requestPermissions().then(result => {
            console.log('PushNotifications result', JSON.stringify(result));
        }).catch(err => {
            console.log('PushNotifications err', JSON.stringify(err));
        })
    },

    localRequestPermission: async () => {
        return await LocalNotifications.requestPermissions().then(result => {
            console.log('LocalNotifications result', JSON.stringify(result));
        }).catch(err => {
            console.log('LocalNotifications err', JSON.stringify(err));
        })
    },

    init: async (onRegisterSuccess = () => { }, onRegisterError = () => { }) => {
        if (!(await Device.isSmartPhone()) && !Device.isStandalone()) {
            console.log('Web push notifications are not supported, moving on...');
            return;
        }

        if (!registrationListener) {
            registrationListener = PushNotifications.addListener('registration', (token) => {
                onRegisterSuccess(token);
            });
        }

        if (!registrationErrorListener) {
            registrationErrorListener = PushNotifications.addListener('registrationError', (error) => {
                onRegisterError(error);
            });
        }
    },

    requestPermissions: async () => {
        if (await Device.isSmartPhone()) {
            console.log('se piden permisos...');
            await Notifications.pushRequestPermission()
            await Notifications.localRequestPermission()
        } else {
            console.log('es web');
        }
    },

    async register(successCallback = () => { }, onNotificationActionPerformed = () => { }, onPushNotificationReceived = () => { }) {
        if (!(await Device.isSmartPhone())) {
            if (Device.isStandalone()) {
                const isIos = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
                const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent);
                if (isIos() || isSafari) return;

                console.log('running web push notifications...')
                const messaging = firebase.messaging()
                let vapidKey = process.env.VUE_APP_FIREBASE_VAPID_KEY || null

                try {
                    await messaging.requestPermission();
                    const token = await messaging.getToken({ vapidKey });
                    successCallback(token);
                } catch (err) {
                    console.log('No permission to notify:', err);
                }
                return;

            } else {
                console.log('web push notifications are not supported, moving on...')
                return
            }
        }

        if (registrationListener) return;

        const isIphone = await Device.isIphone()
        PushNotifications.register().then(() => console.log(`Registered for push`));

        if (isIphone) {
            registrationListener = PushNotifications.addListener('registration', () => { });
            FCM.getToken().then(r => successCallback(r.token)).catch(err => console.log(err));
        } else {
            registrationListener = PushNotifications.addListener('registration', (token) => {
                successCallback(token.value)
            });
        }

        Notifications.onReceived(onPushNotificationReceived)
        Notifications.onActionPerformed(onNotificationActionPerformed)
    },

    onReceived: (cb = () => { }) => {
        if (notificationReceivedListener) return
        PushNotifications.addListener('pushNotificationReceived', (notification) => {
            cb(notification);
        });
    },

    onActionPerformed: (cb = () => { }) => {
        if (notificationsListener) return
        PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
            cb(notification);
        });
    },

}

export const Device = {
    isSmartPhone: async () => {
        const info = await Device.getInfo()
        return info.platform === 'ios' || info.platform === 'android'
    },

    isIphone: async () => {
        const info = await Device.getInfo()
        return info.model === 'iPhone'
    },

    isIOS: async () => {
        const info = await Device.getInfo()
        return info.platform === 'ios'
    },

    isAndroid: async () => {
        const info = await Device.getInfo()
        return info.platform === 'android'
    },

    isWeb: async () => {
        const info = await Device.getInfo()
        return info.platform === 'web'
    },

    getPlatform: async () => {
        const info = await Device.getInfo()
        return info.platform
    },

    getInfo: async () => await CapacitorDevice.getInfo(),

    isStandalone: () => {
        return (
            window.matchMedia('(display-mode: standalone)').matches ||
            window.navigator.standalone ||
            document.referrer.includes('android-app://')
        );
    },
}

export const StatusBar = {
    setStyle: async (type = 'dark') => {
        if (!(await Device.isSmartPhone())) return;
        let style = type === 'dark' ? 'DARK' : 'LIGHT';
        await CapacitorStatusBar.setStyle({ style });
    },

    setBackgroundColor: async (color = '#fff') => {
        if (!(await Device.isSmartPhone())) return;
        await CapacitorStatusBar.setBackgroundColor({ color })
    },

    hide() {
        CapacitorStatusBar.hide();
    },

    show() {
        CapacitorStatusBar.show();
    }
}

export const Screen = {
    setLandscape: () => {
        ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.LANDSCAPE);
    },
    setPortrait: () => {
        ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT);
    },
    unlock: () => {
        ScreenOrientation.unlock();
    }
}
